import type { PrismaMediaDto } from 'app/API';

export type TMediaAnalysisRecord = {
  analysisStatus: NonNullable<PrismaMediaDto['analysisStatus']> | null;
  duration: number;
};

const ANALYSIS_STATUSES: ReadonlyArray<TMediaAnalysisRecord['analysisStatus']> = [
  'PENDING',
  'CORE_READY',
  'COMPLETE',
  'FAILED',
];

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

export const collectMediaAnalysisRecords = (media: unknown[]): Record<string, TMediaAnalysisRecord> =>
  Object.fromEntries(
    media.flatMap((item) => {
      if (!isRecord(item) || typeof item.Id !== 'string' || item.Id === '') {
        return [];
      }
      const analysisStatus = ANALYSIS_STATUSES.find((status) => status === item.analysisStatus) ?? null;
      return [[item.Id, { analysisStatus, duration: Number(item.duration) || 0 }]];
    }),
  );
